export default "__VITE_ASSET__82Oh3xh0__"